module.exports = __webpack_public_path__ + "static/logo-horizontal-30f6ab277f0a41d2d1643a2839645c0c.svg";